import { parseJson, abbreviateNumber } from "src/shared/utils";
import { Aggregation } from "./DetailsModel";

interface IChartData {
  cache_key?: any;
  cached_dttm?: any;
  cache_timeout: number;
  error?: any;
  is_cached: boolean;
  query: string;
  status: string;
  stacktrace?: any;
  rowcount: number;
  data: Data;
}

interface Data {
  data: number[][];
  compare_lag: number;
  compare_suffix: string;
}
export default class MetricModel {
  public id: number;
  public metricId: number;
  public label: string;
  public aggregations: Array<Aggregation>;
  public filters: { [key: string]: string[] }[];
  public performanceChartIds: string[];
  public currentChart: number | IChartData;
  public pastChart: number;
  public trendChart: number;
  public filterSliceId: number;
  public hasChart?: boolean;
  public notes: [
    {
      text: string;
      updatedAt: string;
    }
  ];
  public isPercentage: boolean;
  public isPositive: boolean;
  public isAnomalous: 0 | 1 | 2;
  public isStaleMetric: string;
  public lowerBound: number;
  public upperBound: number;
  public owner: string;
  public dataset: string;
  public freshness: number;
  public sla: number;
  public time_stamp: string;
  public isHidden: string;
  public message: string;
  public unit?: string;

  public constructor(obj: any) {
    this.id = obj.id;
    this.metricId = obj.metricId || obj.id;
    this.label = obj.label;
    this.filters = obj.filters ? parseJson(obj.filters).filter((item) => item.value.length !== 0) || [] : [];
    this.performanceChartIds = (parseJson(obj.performanceChartIds) || []).map(
      (item) => (item ? abbreviateNumber(item) : "0") // Old logic: show - if value = 0, new logic: show the number directly
    );
    this.currentChart = obj.currentChartId;
    this.pastChart = obj.pastChartId;
    this.notes = (obj.notes && Array.isArray(obj.notes) && obj.notes.slice(0, 3)) || [];
    this.trendChart = obj.trendChartId;
    this.filterSliceId = obj.filterChartId || 0;
    this.hasChart = false;
    this.isPercentage = obj.isPercentage;
    this.isAnomalous = obj.isAnomalous ? 1 : 0;
    this.isStaleMetric = "";
    this.isPositive = obj.isPositive;
    this.lowerBound = obj.lowerBound;
    this.upperBound = obj.upperBound;
    this.aggregations = parseJson(obj.aggregations);
    this.owner = obj.owner;
    this.dataset = obj.dataset;
    this.freshness = obj.freshness;
    this.sla = obj.sla;
    this.time_stamp = obj.time_stamp;
    this.isHidden = obj.isHidden;
    this.message = obj.message;
    this.unit = obj.unit;
  }
  public static createMetric(data: any) {
    return new MetricModel(data);
  }
  public isChartID(chart: IChartData | number): chart is number {
    return typeof chart === "number";
  }
}
